import React, { useState } from "react";import { LogOut, User, Users, Bell, Shield, Sparkles, ChevronRight, Heart, Repeat, History, Tags, BarChart3 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import ScreenHeader from "../components/layout/ScreenHeader";
import CoupleSection from "../components/CoupleSection";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";

export default function Configuracion() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success("Sesión cerrada");
    navigate("/welcome", { replace: true });
  };

  return (
    <div data-testid="configuracion-screen">
      <ScreenHeader
        eyebrow="Tu cuenta"
        title="Ajustes"
        subtitle="Personaliza tu experiencia en FiPer."
      />

      {/* Profile card */}
      <div className="px-6">
        <div className="rounded-3xl bg-white border border-line/70 shadow-card p-5 flex items-center gap-4">
          <div className="h-14 w-14 rounded-2xl bg-sage-900 text-bone flex items-center justify-center font-display font-extrabold text-xl">
            {user?.name?.[0]?.toUpperCase() || "F"}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-display font-bold text-lg truncate">{user?.name}</p>
            <p className="text-sm text-soft truncate">{user?.email}</p>
          </div>
        </div>
      </div>

      {/* Couple / household management */}
      <CoupleSection />

      {/* Settings list */}
      <div className="px-6 mt-8 space-y-2">
        <Link to="/historial" data-testid="setting-historial-link">
          <SettingRow icon={History} title="Historial de meses" hint="Tu trayectoria del saldo real" testid="setting-historial" />
        </Link>
        <Link to="/categorias" data-testid="setting-categorias-link">
          <SettingRow icon={Tags} title="Categorías" hint="Personaliza ingresos y gastos" testid="setting-categorias" />
        </Link>
        {user?.role === "admin" && (
          <Link to="/admin" data-testid="setting-admin-link">
            <SettingRow icon={BarChart3} title="Pulso (owner)" hint="Métricas internas del producto" testid="setting-admin" />
          </Link>
        )}
        <Link to="/recurrencias" data-testid="setting-recurrencias-link">
          <SettingRow icon={Repeat} title="Gastos fijos / Recurrencias" hint="Gestiona tus compromisos repetitivos" testid="setting-recurrencias" />
        </Link>
        <SettingRow icon={Bell} title="Notificaciones" hint="Próximamente" testid="setting-notifications" />
        <SettingRow icon={Shield} title="Seguridad" hint="Cambiar contraseña" testid="setting-security" />
        <SettingRow icon={Sparkles} title="Acerca de FiPer" hint="Versión 0.4.0 · Fase 4" testid="setting-about" />
      </div>

      {/* Logout */}
      <div className="px-6 mt-8 pb-10">
        <button
          type="button"
          onClick={handleLogout}
          data-testid="logout-button"
          className="w-full flex items-center justify-center gap-2 bg-clay/10 text-clay font-bold rounded-2xl py-4 hover:bg-clay/15 transition-colors"
        >
          <LogOut size={16} /> Cerrar sesión
        </button>
        <p className="text-center text-xs text-soft mt-6">
          Hecho con cariño para ayudarte a entender tu dinero real.
        </p>
      </div>
    </div>
  );
}

function SettingRow({ icon: Icon, title, hint, testid }) {
  return (
    <div
      data-testid={testid}
      className="rounded-2xl bg-white border border-line/70 px-4 py-3.5 flex items-center gap-3"
    >
      <div className="h-10 w-10 rounded-xl bg-sage-50 text-sage-700 flex items-center justify-center shrink-0">
        <Icon size={18} strokeWidth={1.8} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-ink">{title}</p>
        {hint && <p className="text-xs text-soft">{hint}</p>}
      </div>
      <ChevronRight size={18} className="text-soft" />
    </div>
  );
}
